import { Component, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'copo-back-button',
	templateUrl: './back-button.component.html',
	styleUrl: './back-button.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [MatButtonModule, MatIconModule]
})
export class BackButtonComponent {
	constructor(
		private readonly location: Location
	) {}

	getBack() {
		this.location.back();
	}
}
